import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';

import TableWithSummary from '../../../../../components/table/TableWithSummary';
import {
  ORDER_ALL_LIST_FILTER_OPTION_MODEL,
  ORDER_ALL_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/order/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ORDER_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/orderConstants';
import columns from './columns';
import { orderActions } from '../../../../../store/modules/order';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../../constants/service/common/utilConstants';

const OrderAllList = ({ getList, pageName }) => {
  const dispatch = useDispatch();

  const { email } = useSelector((state) => state.app.adminInfo);
  const { list, filterOption, sortOption, searchOption, pagination, summary } = useSelector(
    (state) => state.order.orderAllList,
  );
  const mainProductCategorySelectList = useSelector((state) => state.order.mainProductCategorySelectList);

  const setData = (data) => dispatch(orderActions.setData(data));
  const getOrderAllListExcelDownload = (data) => dispatch(orderActions.getOrderAllListExcelDownload(data));

  /**
   * 엑셀 다운로드
   */
  const getExcelDownload = () => {
    if (!list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderAllListExcelDownload({
      email,
      searchOption,
      filterOption,
      sortOption,
      orderPageName: pageName,
    });
  };

  return (
    <div className="order-all-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: ORDER_ALL_LIST_FILTER_OPTION_MODEL,
          sortOption: ORDER_ALL_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        getExcelDownload={getExcelDownload}
        isStriped={true}
        emptyText={ORDER_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        columns={(utils) =>
          columns({
            setData,
            mainProductCategorySelectList,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default OrderAllList;
